import React, { useState } from "react";
import "../../styles/components/AboutHero.css";

import heroBg from "../../img/hero/about-hero-12.webp";      // правий арт (ДНК/хмари)
import btnArrow from "../../img/hero/arrow-herro.png";   // стрілка на кнопці

import Modal from "../../components/Modal";           // ✅ модалка
import ContactFormSimple from "../../components/ContactFormSimple"; // ✅ форма

export default function AboutHero() {
  const [openModal, setOpenModal] = useState(false);

  return (
    <section className="about-hero about-hero-anim" aria-label="About us hero">
      {/* Правий образ */}
      <img
        className="hero-bg-img about-hero-anim__art"
        src={heroBg}
        alt=""
        aria-hidden="true"
      />

      {/* Лівий блок зі заголовком */}
      <div className="hero-art-left about-hero-anim__title">
        <h1 className="hero-title">
          We've been building <strong>AI</strong> that knows
          <br />
          <strong>your users</strong> since 2023
        </h1>
      </div>

      {/* Рядок: місія + кнопка */}
      <div className="hero-bottom about-hero-anim__bottom">
        <p className="hero-mission">
          Personalized agents for millions of users.
          We know what works.
        </p>

        <button
          className="Secondary v2"
          type="button"
          onClick={() => setOpenModal(true)}
        >
          <span className="Secondary__text">Start Your Project</span>
          {btnArrow ? (
            <img
              className="Secondary__circle"
              src={btnArrow}
              alt=""
              aria-hidden="true"
            />
          ) : (
            <span className="Secondary__circle">➜</span>
          )}
        </button>
      </div>

      {/* Модалка з формою */}
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        title="Start your project"
      >
        <ContactFormSimple onSubmit={() => setOpenModal(false)} />
      </Modal>
    </section>
  );
}
